import React, { FC } from "react";
import styles from "./appointment-request-tag.module.scss";
import { Resource_AppointmentStatus } from "../../src/generated/graphql";
import { Maybe } from "graphql/jsutils/Maybe";
import {
  AppointmentStatusBadgeColors,
  AppointmentStatusTitles,
  AppointmentStatusTitlesShort,
} from "../../helpers/enum-maps";
import { useIntl } from "react-intl";
import { Tooltip } from "antd";

interface AppointmentStatusTagProps {
  status: Maybe<Resource_AppointmentStatus> | undefined;
  unverified: Maybe<boolean> | undefined;
}

export const AppointmentStatusTag: FC<AppointmentStatusTagProps> = ({
  status,
  unverified,
}) => {
  const { formatMessage } = useIntl();

  const colorSet = AppointmentStatusBadgeColors.get(
    status || Resource_AppointmentStatus.AppointmentStatusNone
  );

  return (
    <Tooltip
      title={
        unverified
          ? formatMessage({
              id: "appointment.not-verified.description",
            })
          : formatMessage({
              id: AppointmentStatusTitles.get(
                status || Resource_AppointmentStatus.AppointmentStatusNone
              ),
            })
      }
    >
      <span
        className={styles.appointmentRequestTag}
        style={{
          backgroundColor: unverified ? "darkred" : colorSet?.[0],
          color: unverified ? "white" : colorSet?.[1],
          border: `1px solid ${colorSet?.[1]}`,
        }}
      >
        {unverified
          ? formatMessage({ id: "appointment.not-verified" })
          : formatMessage({
              id: AppointmentStatusTitlesShort.get(
                status || Resource_AppointmentStatus.AppointmentStatusNone
              ),
            })}
      </span>
    </Tooltip>
  );
};
